export const PMCantApproveKypTypeValues = ['OM Product', 'Private Product', 'Derivatives', 'Small Cap Stock'];

export const KypSelectableTypeValues = ['Mutual Fund', 'ETF', 'Common Stock', 'Preferred Stock', 'Bond', ...PMCantApproveKypTypeValues];
export const KypDeprecatedTypeValues = ['Cash', 'Equity', 'Equity Option', 'Fund', 'FX Forward', 'FX Option', 'OM'];
export const KypTypeValues = [...KypSelectableTypeValues, ...KypDeprecatedTypeValues] as const;
export type KypType = typeof KypTypeValues[number];

export const KypSelectableApprovedForValues = ['firm-wide', 'client'];
export const KypDeprecatedApprovedForValues = ['partner', 'model'];
export const KypApprovedForValues = [...KypSelectableApprovedForValues, ...KypDeprecatedApprovedForValues] as const;
export type KypApprovedFor = typeof KypApprovedForValues[number];

export const KypSortOptions = ['Newest', 'Oldest', 'Alphabetical', 'Ticker'] as const;
export type KypSortOption = typeof KypSortOptions[number];

export const KypStatusValues = ['pending', 'approved', 'expired'] as const;
export type KypStatus = typeof KypStatusValues[number];

export const KypFilteringDateOptions = ['Last Updated', 'Created', 'Last Reviewed'] as const;
export type KypFilteringDate = typeof KypFilteringDateOptions[number];

export const KypAssetClassOptions = ['Cash & Cash Equivalents', 'Equity', 'Fixed Income', 'Alternatives'] as const;
export type KypAssetClass = typeof KypAssetClassOptions[number];

export const KypDateFieldNames = ['lastUpdated', 'reviewDate', 'startTime'] as const;
export type KypDateField = typeof KypDateFieldNames[number];

export type KypFormType = 'create' | 'edit' | 'review' | 'filter';

export type Kyp = {
  uuid: string;
  name: string;
  type: KypType | '';
  ticker: string;
  partner: number;
  isinCode: string;
  approvedFor: KypApprovedFor | undefined;
  assessment: string;
  startTime: string;
  createdBy: string;
  lastUpdated: string;
  lastUpdatedBy: string;
  reviewedBy: string;
  reviewDate: string;
  reviewStatus: KypStatus;
  isApproved: 0 | 1;
  isExpired: boolean;
  assetClass: KypAssetClass | undefined;
};

export type KypFilters = {
  type: KypType | null;
  reviewStatus: KypStatus | null;
  approvedFor: KypApprovedFor | null;
  partner: number | null;
  filteringDate: KypFilteringDate | null;
  startDate: Date | string | null;
  endDate: Date | string | null;
  isExpired: boolean | null;
};

export type KypComparator = (a: Kyp, b: Kyp) => number;
